<template>
    <div class="equipe" v-if="partie!=null">
        
        <div v-if="equipe ">
            <div v-if="!forme">
                <equipe-item
                    :equipeJoueur="equipe[type].J1"
                    JX="J1"
                    :type="type"
                    :changeFlagJoueur="changeFlagJoueur"
                    :showError="showError"
                    :indexPartie="indexPartie"
                    :theme="theme"
                    :joueurs="joueurs"
                    @errorJoueur = "errorJoueur"
                    @editJoueur = "editJoueur"
                />
                <equipe-item
                    :equipeJoueur="equipe[type].J2"
                    JX="J2"
                    :type="type"
                    :changeFlagJoueur="changeFlagJoueur"
                    :showError="showError"
                    :indexPartie="indexPartie"
                    :theme="theme"
                    :joueurs="joueurs"
                    @errorJoueur = "errorJoueur"
                    @editJoueur = "editJoueur"
                />
                <equipe-item
                    :equipeJoueur="equipe[type].J3"
                    JX="J3"
                    :type="type"
                    :changeFlagJoueur="changeFlagJoueur"
                    :showError="showError"
                    :indexPartie="indexPartie"
                    :theme="theme"
                    :joueurs="joueurs"
                    @errorJoueur = "errorJoueur"
                    @editJoueur = "editJoueur"
                />
            </div>
            <div v-if="forme">
                <equipe-item-forme
                    :equipe="equipe"
                    :type="type"
                    :changeFlagJoueur="changeFlagJoueur"
                    :showError="showError"
                    :indexPartie="indexPartie"
                    :theme="theme"
                    :joueurs="joueurs"
                    @errorJoueur = "errorJoueur"
                    @editJoueur = "editJoueur"
                />
            </div>
                <div v-if="equipe[type]" > 
                    <p class="control has-icons-left " v-show="equipe.state=='FINISH'">
                        <div :class="type=='joueurs' ? 'scoreJ' : 'scoreC'" v-if="equipe.state=='FINISH'">
                            {{equipe.score[type]}}
                        </div>
                    </p>
                    <p class="control" v-show="equipe.state!='FINISH' && displayNormal">
                    
                        <s-button 
                            :label="((isNaN(equipe.score[type]) || equipe.score[type]==null) ? '' : equipe.score[type])+' ? '" 
                            theme="is-medium" 
                            @onclick="openModalScore"
                            :disabled="partie.state=='WAITING' || (role!='owner' && role!='admin')"
                            :id="equipe.id+'_'+type"
                        />
                    </p>
                    <span v-show="!displayNormal">&nbsp;<br/><br/></span>
                </div>
        
        </div>
    </div>
</template>
<style scoped>
    input:disabled{
        background-color: rgb(83, 83, 83);
        color: white;
    }
    input {
        font-weight: bolder;
    }
    .scoreJ {
         background-color: rgb(7, 60, 95);
        padding: 5px;
        border-radius: 10px;
        color: white;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 5px;
        font-size: 20px;
        font-weight:bolder;
    }
     .scoreC {
        background-color: rgb(138, 14, 14);
        padding: 5px;
        border-radius: 10px;
        color: white;
        margin-left: 10px;
        margin-right: 10px;
         margin-top: 5px;
        font-size: 20px;
        font-weight:bolder;
    }
   
    
    
</style>
<script>
import equipeItem from  "@/views/tournoi/inProgress/equipe/equipeItem.vue"
import equipeItemForme from  "@/views/tournoi/inProgress/equipe/equipeItemForme.vue"
import listErrors from "@/views/tournoi/inProgress/listErrors.vue"
import EquipeItem from '../equipeItem.vue'
export default {
    props: {
        mode: {
            type: String,
            detault: ""
        },
         partie: {
            type: [Object,Array]
        }, 
        equipe: {
            type: [Object,Array]
        }, 
        options: {
            type: [Object,Array]
        }, 
        
        joueurs: Array, 
        type: String, 
        changeFlagJoueur: Boolean,
        disabledScore: {
            type: Boolean,
            default: false
        },
        showError: {
            type: Boolean,
            default: false
        },
        indexPartie: {
            type: Number
        },
        role: {
            type: String,
            default: "owner"
        },
        theme: {
            type: String,
            default: null
        }
        },
    components: {
        listErrors,
        equipeItem,
        equipeItemForme
    },
    data() {
            return {
                openJoueurModify : false,
                joueurSelected: null,
                error: false
            }
        },
    computed: {
        
        maxScore: {
            get() {
                var maxPoint = 13;
                if (this.partie != null)
                    if (typeof(this.partie.maxPoint) != "undefined")
                        maxPoint = this.partie.maxPoint;
                return maxPoint;
            }
            
        },
        getTheme: {
            get() {
                if (this.theme == null)
                    return this.type=='joueurs' ? 'is-small is-primary' : 'is-small is-danger'
                else
                    return this.theme + " is-small"
            }
        },
        getClassInput: {
            get() {
                if (this.theme == null)
                    return this.type=='joueurs' ? 'input is-primary is-medium' : 'input is-danger is-medium'
                else
                    return this.theme + " input is-medium";
            }
        },
        forme: {
            get() {
                return (this.mode == "FORME")
            }
        },
        displayNormal: {
            get() {
              
                if (this.options) {
                    if (this.options.allEquipePlay)
                        return true;
                    else if (this.options.addPartie) {
                         if (this.equipe["joueurs"].J2 == null || this.equipe["contre"].J1==null)
                            return false;
                        else
                            return true;
                    }
                    else    
                        return true;
                    }
               else return true;
            }
        }
        
    },
    methods: {
      
        openModalScore() {
            this.$emit("openModalScore",this.equipe, this.type);
        },
        openModalJoueur(errorDetail) {
         
            this.$emit("openModalJoueur", errorDetail);
        },
        changeScoreOut() {
            var typeVS = this.type == "contre" ? "joueurs" : "contre";
            if (this.equipe.score[this.type]!=null) {
                if (this.equipe.score[this.type]!=this.maxScore) {
                    var score = parseInt(this.equipe.score[this.type]);
                    if (!isNaN(score)) {
                        this.equipe.score[typeVS] = this.maxScore;
                    } 
                }
                /*if (this.equipe.score[this.type] == '')
                    this.equipe.score[this.type] = 0;*/
                if (this.equipe.score[this.type] < 0)
                    this.equipe.score[this.type] = 0;
                
                
                this.error = (this.equipe.score[this.type] > this.maxScore );
            
                this.$emit("saveScore",this.equipe);
            }
        },
        errorJoueur(joueur) {
            if (this.showError) {
                if (joueur) 
                        return joueur.errorDetail[this.indexPartie] != "undefined";
                    else
                        return false;
            }
            else
                return false
            
        },
        
        editJoueur(joueur, vs, idJoueur) {
         
            this.joueurSelected = joueur;
            if (this.changeFlagJoueur) {
                if (joueur == null) {
                    this.joueurSelected = {
                        numero: null,
                        vs: vs,
                        idJoueur: idJoueur
                    }
                }
               
                this.$emit("changeEffect", this.joueurSelected, this.equipe)
            }
            else {
                
                this.openJoueurModify = true;
                this.$emit("selectJoueur", this.joueurSelected, this.equipe)
            }
        },
        changeScore() {
            this.$emit("change", this.equipe);
        }
        
    }
}
</script>